import { getAds } from './api/calls';

export function passback (data) {
    window.parent.postMessage({
        app: 'parkave',
        event: 'passback',
        item: data
    }, '*')
}

export function close () {
    window.parent.postMessage({
        app: 'parkave',
        event: 'close'
    }, '*')
}

/**
 * Allow other applications, inluding ParkAve,
 * to get recently created advertisements
 */
export function allowBoostrapCall () {

    window.addEventListener('message', function (event) {
        if (event.data.app == 'parkave') {
            if (event.data.event == 'bootstrap_request') {
                getAds().then((ads) => {
                    let logged_in = true;
                    if (ads.error) {
                        logged_in = false;
                        ads = [];
                    } else {
                        ads = ads.map(function (o) {
                            return {
                                name: o.name,
                                placement_id: o.placement_id,
                                inputs: JSON.parse(o.json || '{}')
                            }
                        })
                    }
                    event.source.postMessage({
                        app: 'parkave',
                        event: 'bootstrap_response',
                        ads: ads,
                        logged_in: logged_in
                    }, '*');
                });
            }
        }
    }.bind(this), false)
}


// WEBPACK FOOTER //
// ./src/lib/integration.js